// Breadcrumb label for the academic attendance/report pages, based on the user's
// positions. Level heads (21 = ม.ต้น / 22 = ม.ปลาย) reuse the Academic Head report
// pages, so the breadcrumb must reflect their own role instead of always showing
// "หัวหน้าวิชาการสามัญ". Academic head / admin (3, 4, 17, 99) take precedence —
// they see all levels, so they keep the academic-head label.
export const getAcademicReportRoleLabel = (posIds = []) => {
  const has = (p) => Array.isArray(posIds) && posIds.includes(p);
  if (has(3) || has(4) || has(17) || has(99)) return 'หัวหน้าวิชาการสามัญ';
  if (has(21)) return 'หัวหน้าระดับ ม.ต้น';
  if (has(22)) return 'หัวหน้าระดับ ม.ปลาย';
  return 'หัวหน้าวิชาการสามัญ';
};

// Breadcrumb label for the Student Tracking / Early-Warning dashboard, which is
// shared by more roles than the academic report pages (adds ครูประจำชั้น and
// ฝ่ายปกครอง). Widest access wins, matching authController.attachTrackingScope.
export const getTrackingRoleLabel = (posIds = []) => {
  const has = (p) => Array.isArray(posIds) && posIds.includes(p);
  if (has(3) || has(4) || has(17) || has(99)) return 'หัวหน้าวิชาการสามัญ';
  if (has(16)) return 'ฝ่ายปกครอง';
  if (has(21)) return 'หัวหน้าระดับ ม.ต้น';
  if (has(22)) return 'หัวหน้าระดับ ม.ปลาย';
  if (has(2)) return 'ครูประจำชั้น';
  return 'ติดตามนักเรียน';
};

// Suffix appended to a page's main title so a level head sees which level the
// data is scoped to, e.g. "รายชื่อนักเรียนรายห้อง (ม.ต้น)". Academic head / admin
// (3, 4, 17, 99) see all levels, so they get no suffix.
export const getLevelSuffix = (posIds = []) => {
  const has = (p) => Array.isArray(posIds) && posIds.includes(p);
  if (has(3) || has(4) || has(17) || has(99)) return '';
  if (has(21)) return ' (ม.ต้น)';
  if (has(22)) return ' (ม.ปลาย)';
  return '';
};
